import React, { useState } from 'react';
import clsx from 'clsx';
import Icon from '../../Icon';
import { post } from '../../../Services/http';
import { translate } from '../../../Services/translation';

const HeaderDropdown = ({
  options,
  selectedOption,
}: {
  selectedOption: string;
  options: string[];
}) => {
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);

  const onTypeClick = (event) => {
    event.preventDefault();
    var value = event.target.dataset.value;
    post(`/api/pricetoggle/${value}`, {}).then(() => location.reload());
  };

  return (
    <div
      className={clsx('relative hidden w-full cursor-pointer lg:block')}
      onBlur={() => setDropdownOpen(false)}
      tabIndex={1}
    >
      <div
        onClick={() => setDropdownOpen(!dropdownOpen)}
        className="flex items-center gap-0.5 text-topBarText"
      >
        {translate(`price-toggle.${selectedOption.toLowerCase()}`)}
        <Icon
          name="caret-down"
          className={clsx(
            dropdownOpen && 'rotate-180',
            'transition-transform'
          )}
        />
      </div>
      {dropdownOpen && (
        <ul className="absolute right-0 top-full z-10 mt-2 min-w-full whitespace-nowrap border border-solid border-black bg-gray-800 text-white ">
          {options?.map((option) => (
            <li
              className="flex items-center gap-2 bg-gray-800 p-1.5 px-2 text-md hover:bg-gray-700"
              key={option}
              onClick={(e) => onTypeClick(e)}
              data-value={option}
            >
              {translate(`price-toggle.${option.toLowerCase()}`)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default HeaderDropdown;
